/* eslint-disable no-restricted-syntax */
import { FrontOptions, UsuarioResponse } from "domain/types/usuario/usuarioResponse";
import { GetState } from "../../store/baseStore";
import { AuthenticationService } from "domain/services/authentication/authenticationService";
import { Redirect, RouteParamters } from "../../utils/routeUtil";
import { ResponseValid } from "domain/utils/ReactUtils";
import { GetAuthRoute } from "domain/types/sistema/sistemaList";
import { StoreAplication } from "../../main";
import { IgnoreHeader, IgnoreSideBar, SetUserData } from "../../store/util/action/utilAction";
import { persistStore } from 'redux-persist';

class LocalStorage {
    private cachedData: Record<string, unknown> | null = null;

    constructor() {
        this.LoadCachedData();
    }

    // Simple custom encryption/decryption methods
    private encrypt(text: string, key: string): string {
        let result = '';
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
            result += String.fromCharCode(charCode);
        }
        // Convert to base64 for safe storage
        return btoa(result);
    }

    private decrypt(encryptedText: string, key: string): string {
        try {
            // Convert from base64
            const text = atob(encryptedText);
            let result = '';
            for (let i = 0; i < text.length; i++) {
                const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
                result += String.fromCharCode(charCode);
            }
            return result;
        } catch (error) {
            return '';
        }
    }

    private LoadCachedData(): void {
        const secretKey = this.GetSecret();
        if (!secretKey) return;

        const encryptedValue = localStorage.getItem("UserData");
        if (!encryptedValue) {
            this.cachedData = {};
            return;
        }

        try {
            const decryptedData = this.decrypt(encryptedValue, secretKey);
            this.cachedData = JSON.parse(decryptedData);
        } catch (error) {
            this.cachedData = {};
        }
    }

    Crypt(key: string, value: string) {
        const secretKey = this.GetSecret();
        if (!secretKey) return;

        if (this.cachedData === null) {
            this.LoadCachedData();
        }

        // Atualiza
        this.cachedData = { ...this.cachedData, [key]: value };

        const updatedData = JSON.stringify(this.cachedData);
        const newEncryptedValue = this.encrypt(updatedData, secretKey);

        localStorage.setItem("UserData", newEncryptedValue);
    }

    Decrypt(key: string) {
        if (this.cachedData === null) { //Se não existir Cache, carrega o cache
            this.LoadCachedData();
        }

        return this.cachedData?.[key];
    }

    SaveSecret(secret: string) {
        localStorage.setItem("UserData_", secret);
        this.cachedData = null;
    }

    GetSecret() {
        const result = localStorage.getItem("UserData_")
        return result;
    }


    Set<T>(key: string, value: T) {
        if (typeof value === 'object' && value !== null) {
            const result = JSON.stringify(value);
            this.Crypt(key, result)
        } else {
            this.Crypt(key, String(value))
        }
    }

    Get<T>(key: string): T {
        const result = this.Decrypt(key) as T
        if (typeof result === 'string') {
            try {
                const object = JSON.parse(result);
                if (typeof object == "object") {
                    return object as T
                }
            }
            catch {
                return result;
            }
        }

        return result
    }


    GetAllDecrypted(): Record<string, unknown> {
        if (this.cachedData === null) {
            this.LoadCachedData();
        }

        const result: Record<string, unknown> = {};

        for (const key in this.cachedData) {
            const raw = this.cachedData[key];
            if (typeof raw === "string") {
                try {
                    const parsed = JSON.parse(raw);
                    result[key] = parsed;
                } catch {
                    result[key] = raw;
                }
            } else {
                result[key] = raw;
            }
        }

        return result;
    }

    // Delete(key: string) {
    //     if (this.cachedData === null) {
    //         this.LoadCachedData();
    //     }

    //     if (this.cachedData && key in this.cachedData) {
    //         delete this.cachedData[key];

    //         const secretKey = this.GetSecret();
    //         if (secretKey) {
    //             const updatedData = JSON.stringify(this.cachedData);
    //             const newEncryptedValue = this.encrypt(updatedData, secretKey);
    //             localStorage.setItem("UserData", newEncryptedValue);
    //         }
    //     }
    // }

    Clear() {
        localStorage.clear();
        this.cachedData = {};
    }
}

/* eslint-disable no-unused-vars */
export enum UserDataBaseEnum {
    UsuarioID = "UsuarioID",
    NomeCompleto = "NomeCompleto",
    NomeExibicao = "NomeExibicao",
    UsuarioAcesso = "UsuarioAcesso",
    DataNascimento = "DataNascimento",
    Email = "Email",
    Token = "Token",
    TokenAES = "TokenAES",
    EmpresaID = "EmpresaID",
    ImagemUrl = "ImagemUrl",
    ChavePix = "ChavePix",
    TokenPushNotification = "TokenPushNotification",
    ManterConectado = "ManterConectado",
    TelefoneCelular = "TelefoneCelular",
    RefreshToken = "RefreshToken",
    ExpiresIn = "ExpiresIn"
}

// type UserDataBaseType = {
//     [key in UserDataBaseEnum]: string;
// };

export class UserData {
    private static instance: UserData = new UserData();
    private static load: boolean = false;
    private LocalStorage: LocalStorage = new LocalStorage();


    private constructor() {

    }

    public static get Instance(): UserData {
        //this.LoadUserDataState()
        return this.instance;
    }

    private Set<T>(key: UserDataBaseEnum, value: T) {
        if (typeof value === "string" && value == "undefined") { value = undefined as T }
        this.LocalStorage.Set(key as string, value)
    }

    SetOtherData<T>(key: string, value: T) {
        if (typeof value === "string" && value == "undefined") { value = undefined as T }
        this.LocalStorage.Set(key as string, value)
    }

    GetOtherData<T>(key: string): T {
        let v = this.LocalStorage.Get(key as string) as T
        if (typeof v === "string" && v == "undefined") { v = undefined as T }
        return v
    }


    Get<T>(key: UserDataBaseEnum): T {
        let v = this.LocalStorage.Get(key as string) as T
        if (typeof v === "string" && v == "undefined") { v = undefined as T }
        return v
    }

    // GetAll(): UsuarioResponse {
    //     const result: UsuarioResponse = {} as UsuarioResponse;

    //     for (const key in UserDataBaseEnum) {
    //         const enumKey = key as keyof typeof UserDataBaseEnum;
    //         result[enumKey] = this.LocalStorage.Get(key)
    //     }

    //     return result
    // }

    GetAll(): UsuarioResponse {
        return this.LocalStorage.GetAllDecrypted() as unknown as UsuarioResponse;
    }


    Delete(key: UserDataBaseEnum) {
        this.Delete(key)
    }

    Clear() {
        this.LocalStorage.Clear()
    }

    private async ClearPersistor() {
        try {
            const persistor = persistStore(StoreAplication);
            await persistor.purge();
            await persistor.flush();
        } catch (error) {
            // Error clearing persistor - silently handled
        }
    }

    Register(user: UsuarioResponse) {
        this.LocalStorage.SaveSecret(user.Token + user.UsuarioID)

        for (const key in UserDataBaseEnum) {
            const enumKey = key as keyof typeof UserDataBaseEnum;
            this.Set(UserDataBaseEnum[enumKey], user[enumKey]);
        }

        user.FrontOptions && this.SetFrontOptions(user.FrontOptions);

        this.SetUserDataState(user)
    }

    async LogOut() {
        const SistemaID = GetState().UtilReducer.SistemaID
        const _AuthenticationService = new AuthenticationService();
        const redirect = await _AuthenticationService.LogOut(this.Get(UserDataBaseEnum.UsuarioID));

        // Limpa o localStorage
        new UserData().Clear()

        // Limpa os dados do persistor
        await this.ClearPersistor();

        if (ResponseValid(redirect)) {
            Redirect(redirect as string, [{
                key: RouteParamters.logOut,
                value: true
            },
            {
                key: RouteParamters.sistemaID,
                value: SistemaID
            }
            ])
        } else {
            Redirect(GetAuthRoute())
        }
    }


    private SetUserDataState(usuario: UsuarioResponse) {
        try {
            StoreAplication && StoreAplication.dispatch(SetUserData(usuario)) //Define UseData para acesso publico em todo app
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log("Store não inciado")
        }
    }

    public SetFrontOptions(options: FrontOptions) {
        options.IgnoreHeader != undefined && options.IgnoreHeader === true && StoreAplication.dispatch(IgnoreHeader("*"))
        options.IgnoreSideBar != undefined && options.IgnoreSideBar === true && StoreAplication.dispatch(IgnoreSideBar("*"))
    }


    private static CheckUserDataState() {
        try {
            if (GetState().UtilReducer.UserData == undefined) {
                _UserData.SetUserDataState(_UserData.GetAll());
                return true;
            }
            return false;
        } catch (error) {
            return false
        }
    }

    static LoadUserDataState() {
        if (this.load == false) {
            this.load = this.CheckUserDataState()
        }
    }
}

export const _UserData = UserData.Instance;